import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-left-bar', 'ArrowLeftBar', [["path",{"d":"M21 12h-18"}],["path",{"d":"M6 9l-3 3l3 3"}],["path",{"d":"M21 9v6"}]]);